module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [(_vm.isEditing) ? _c('h2', [_vm._v("Redigér stillingskategori")]) : _c('h2', [_vm._v("Opret ny stillingskategori")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    ref: "input_title",
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": "F.eks. Lærer"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.forceHourLimitMode && !_vm.hasHourLimit) ? _c('div', {
    staticClass: "uv-limit-box"
  }, [_c('div', {
    staticClass: "d-input-group d-input-group--toggler uv-limit-box__toggle",
    class: {
      'd-input-group--toggler--active': _vm.localManualSalary
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setIsManualSalary(!_vm.localManualSalary)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Skal indberettes som vikarløn")]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.localManualSalary
    }
  })], 1), _vm._v(" "), (_vm.localManualSalary) ? _c('div', {
    staticClass: "uv-limit-box__fields"
  }, [_c('div', {
    staticClass: "d-input-group-flex"
  }, [_c('div', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Standard lønkode")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salaryCodeId),
      expression: "salaryCodeId"
    }],
    staticClass: "do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.salaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
    return _c('option', {
      key: salaryCode.id,
      domProps: {
        "value": salaryCode.id
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.salaryCodeLabel(salaryCode)) + "\n                ")])
  })], 2)]), _vm._v(" "), (_vm.costCenters.length > 0) ? _c('div', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Standard omkostningsted")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.omkostningssted),
      expression: "omkostningssted"
    }],
    staticClass: "do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.omkostningssted = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.costCenters), function(costCenter) {
    return _c('option', {
      key: costCenter.code,
      domProps: {
        "value": costCenter.code
      }
    }, [_vm._v("\n                  " + _vm._s(costCenter.title) + "\n                ")])
  })], 2)]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.localManualSalary) ? _c('div', {
    staticClass: "uv-limit-box"
  }, [_c('div', {
    staticClass: "d-input-group d-input-group--toggler uv-limit-box__toggle",
    class: {
      'd-input-group--toggler--active': _vm.hasHourLimit
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleHasHourLimit.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Sæt UV-grænse (§ 5, stk. 2)")]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.hasHourLimit
    }
  })], 1), _vm._v(" "), (_vm.hasHourLimit) ? _c('div', {
    staticClass: "uv-limit-box__fields"
  }, [_c('div', {
    staticClass: "d-input-group-flex"
  }, [_c('div', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("UV-grænse")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hourLimit),
      expression: "hourLimit"
    }],
    ref: "input_hour_limit",
    staticClass: "d-input width-100",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "placeholder": "F.eks. 750"
    },
    domProps: {
      "value": (_vm.hourLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hourLimit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Lønkode over UV-grænse")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hourLimitSalaryCodeId),
      expression: "hourLimitSalaryCodeId"
    }],
    staticClass: "do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hourLimitSalaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
    return _c('option', {
      key: salaryCode.id,
      domProps: {
        "value": salaryCode.id
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.salaryCodeLabel(salaryCode)) + "\n                ")])
  })], 2)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.localManualSalary && _vm.hasSpecialSalaryCode && !_vm.isSalarySystemSD) ? _c('div', {
    staticClass: "uv-limit-box"
  }, [_c('div', {
    staticClass: "d-input-group d-input-group--toggler uv-limit-box__toggle",
    class: {
      'd-input-group--toggler--active': _vm.hasSpecialHourLimit
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleHasSpecialHourLimit.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Specialskole uv-tillæg (§ 5, stk. 4)")]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.hasSpecialHourLimit
    }
  })], 1), _vm._v(" "), (_vm.hasSpecialHourLimit) ? _c('div', {
    staticClass: "uv-limit-box__fields"
  }, [_c('div', {
    staticClass: "d-input-group-flex"
  }, [_c('div', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Lønkode spec-skole UV-tillæg")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.specialHourLimitSalaryCodeId),
      expression: "specialHourLimitSalaryCodeId"
    }],
    staticClass: "do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.specialHourLimitSalaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
    return _c('option', {
      key: salaryCode.id,
      domProps: {
        "value": salaryCode.id
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.salaryCodeLabel(salaryCode)) + "\n                ")])
  })], 2)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSalarySystemSD) ? _c('div', {
    staticClass: "uv-limit-box"
  }, [_c('div', {
    staticClass: "d-input-group d-input-group--toggler uv-limit-box__toggle",
    class: {
      'd-input-group--toggler--active': _vm.enableEmploymentDecimal
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.enableEmploymentDecimal = !_vm.enableEmploymentDecimal
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Indsend lønbrøk")]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.enableEmploymentDecimal
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', [(_vm.isEditing) ? [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'top',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        zIndex: 12312312312312
      }),
      expression: "{\n              arrow: true,\n              placement: 'top',\n              animateFill: false,\n              animation: 'shift-away',\n              boundary: 'window',\n              zIndex: 12312312312312\n            }"
    }],
    staticClass: "do-bttn",
    class: {
      'do-bttn--submit--loading': _vm.isDeleting,
      'do-bttn--delete-confirm': _vm.confirmingDelete,
      'do-bttn--delete-disabled': _vm.isTemplateInUse || _vm.isLoadingUsage
    },
    attrs: {
      "content": _vm.deleteButtonTitle
    },
    on: {
      "click": _vm.onDeleteClick
    }
  }, [(_vm.confirmingDelete) ? _c('span', [_vm._v("Bekræft sletning")]) : _c('span', {
    staticClass: "icon-bin"
  })]), _vm._v(" "), (_vm.confirmingDelete && !_vm.isDeleting) ? _c('button', {
    staticClass: "delete-cancel",
    on: {
      "click": function($event) {
        _vm.confirmingDelete = false
      }
    }
  }, [_vm._v("\n            Fortryd\n          ")]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSubmitting,
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEditing ? 'Opdatér' : 'Opret') + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bccd80f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/DoEmploymentTemplate.vue
// module id = 2111
// module chunks = 1